import { Link } from 'react-router-dom';
import AnimatedSection from './AnimatedSection';

const GALLERY_IMAGES = [
  { src: '/images/jurassic-dinosaur-jeep-performance-050.jpeg', alt: 'Dinosaur puppet emerging from Jurassic Jeep', tall: true },
  { src: '/images/happy-child-dinosaur-mask-021.jpeg', alt: 'Happy child wearing a dinosaur mask' },
  { src: '/images/jurassic-jack-dino-party-2023-044.jpeg', alt: 'Jurassic Jack entertaining kids at a party' },
  { src: '/images/jurassic-jack-dino-fun-collection-040.png', alt: 'Collection of Jurassic Jack performance moments', tall: true },
  { src: '/images/colorful-performance-outdoor-fun-006.jpeg', alt: 'Colorful outdoor performance' },
  { src: '/images/dinosaur-exhibit-library-event-032.jpeg', alt: 'Dinosaur exhibit at library event' },
];

const GalleryHighlight = () => {
  return (
    <section className="py-20 bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection className="text-center mb-14">
          <p className="font-mono text-sm uppercase tracking-[0.2em] text-jp-red mb-2">
            Gallery
          </p>
          <h2 className="text-4xl md:text-5xl font-display text-charcoal">
            A Peek At The <span className="text-amber-700">Adventure</span>
          </h2>
          <p className="mt-4 text-charcoal/60 max-w-2xl mx-auto">
            From roaming encounters to fossil digs and showground photo moments — Jurassic Jack creates the kind of memories people share.
          </p>
        </AnimatedSection>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {GALLERY_IMAGES.map((img, i) => (
            <AnimatedSection
              key={img.src}
              delay={i * 0.08}
              className={img.tall ? 'row-span-2' : ''}
            >
              <div className="group relative rounded-lg overflow-hidden h-full
                              border-2 border-transparent hover:border-amber/40
                              transition-all duration-300 hover:shadow-amber-glow">
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover transition-transform duration-500
                             group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-charcoal/0 group-hover:bg-charcoal/20 transition-colors duration-300" />
              </div>
            </AnimatedSection>
          ))}
        </div>

        <AnimatedSection className="text-center mt-10">
          <Link
            to="/gallery"
            className="inline-flex items-center gap-2 font-display text-lg uppercase tracking-wider
                       text-jp-red hover:text-amber transition-colors"
          >
            View Gallery
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </Link>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default GalleryHighlight;
